// extracted by mini-css-extract-plugin
module.exports = {"last-updated-timer":"last-updated-timer_last-updated-timer__1Or3J","last-updated-timer-tooltip":"last-updated-timer_last-updated-timer-tooltip__10RLp"};